export const deClientPortalNotificationSettingsConstantsPages = {
    settings: {
        constants: {
            notifications: {
                groups: {
                    orders: {
                        newMessage: {
                            title: 'Neue Nachricht zu einem Auftrag',
                            description:
                                'Sie können der Benachrichtigungsliste einer Unterhaltung auch hinzugefügt werden, ohne für den zugehörigen Auftrag zuständig zu sein oder ihn zu beobachten.',
                        },
                        newMention: {
                            title: 'Neue Nachricht mit Ihrer Erwähnung',
                        },
                        newDocument: {
                            title: 'Neues Dokument in einem Auftrag',
                        },
                        inspectionDateUpdated: {
                            title: 'Besichtigungsdatum wurde aktualisiert',
                        },
                        dueDateUpdated: {
                            title: 'Voraussichtliches Fertigstellungsdatum wurde aktualisiert',
                        },
                    },
                    orderStatus: {
                        groupTitle: 'Auftragsstatus',
                        newStatus: {
                            title: 'Neuer Auftragsstatus',
                        },
                        accepted: {
                            title: 'Auftrag wurde angenommen',
                            description: 'Diese Statusänderung wird nicht im Tagesbericht angezeigt.',
                        },
                        blocked: {
                            title: 'Auftrag ist blockiert',
                            description: 'Diese Statusänderung wird nicht im Tagesbericht angezeigt.',
                        },
                    },
                    valuations: {
                        groupTitle: 'Entwürfe und Finalisierung',
                        newDraft: {
                            title: 'Neuer Gutachtenentwurf wurde übermittelt',
                        },
                        finalisedValuation: {
                            title: 'Finalisiertes Gutachten wurde übermittelt',
                        },
                        finalisedValueCheck: {
                            title: 'Finalisierte Wertüberprüfung wurde übermittelt',
                        },
                    },
                    myTasks: {
                        groupTitle: 'Ihnen zugewiesene Aufgaben',
                        assigned: {
                            title: 'Aufgabe wurde Ihnen zugewiesen',
                        },
                        statusChanged: {
                            title: 'Neuer Aufgabenstatus',
                        },
                        newComment: {
                            title: 'Neuer Kommentar zu Ihrer Aufgabe',
                        },
                        dueSoon: {
                            title: 'Ihre Aufgabe ist bald fällig',
                            description: 'Wir informieren Sie 14, 7 und 2 Tage vor der Aufgabendeadline.',
                        },
                        dueTomorrow: {
                            title: 'Ihre Aufgabe ist morgen fällig',
                        },
                    },
                    otherTasks: {
                        groupTitle: 'Weitere Aufgaben',
                        created: {
                            title: 'Neue Aufgabe wurde erstellt',
                        },
                        statusChanged: {
                            title: 'Neuer Aufgabenstatus',
                        },
                        newComment: {
                            title: 'Neuer Kommentar zu einer Aufgabe',
                            description:
                                'Sie können der Benachrichtigungsliste einer Aufgabenunterhaltung auch hinzugefügt werden, ohne für den zugehörigen Auftrag zuständig zu sein oder ihn zu beobachten.',
                        },
                    },
                    plausibility: {
                        newMessage: {
                            title: 'Neue Anmerkung',
                        },
                        editedMessage: {
                            title: 'Anmerkung wurde bearbeitet',
                        },
                        deletedMessage: {
                            title: 'Anmerkung wurde gelöscht',
                        },
                        shared: {
                            title: 'Anmerkungen wurden geteilt',
                        },
                        approved: {
                            title: 'Freigabe eines Entwurfs wurde erteilt',
                        },
                        internalApproved: {
                            title: 'Inhaltliche Freigabe eines Entwurfs wurde durch Fondspartner erteilt',
                        },
                    },
                },
            },
        },
    },
}
